const Thesis = {
  tableConfig: {
    showCheckbox: true,
    comment: '全委托送审与半委托送审管理费和专家费由平台打款，自助送审打款由送审单位与专家线下自行协商。'
  },
  queryList: [
    {
      name: 'sendType',
      label: '送审方式',
      component: 'select',
      componentAttr: {
        options: [{
          value: '1',
          label: '全委托'
        }, {
          value: '2',
          label: '半委托'
        }, {
          value: '3',
          label: '全自助'
        }]
      }
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confFirstSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      component: 'select',
      request: {
        method: 'post',
        addr: '/conf/confSecondSubject/all',
        data: {},
        format: {
          value: 'name',
          label: 'name'
        }
      }
    }
  ],
  urlMap: {
    'select': {
      method: 'post', // 不填默认post
      url: '/exp/expReviewInfo/queryReviewList',
      data: {
        accepts: [2, 3],
        reviews: [0, 1]
      }
    },
    'sendBack': '/exp/expReviewInfo/receiveOrRejectPaperByExp',
    'accept': '/exp/expReviewInfo/receiveOrRejectPaperByExp'
  },
  operList: [// 操作列表
  ],
  titles: [
    {
      name: 'operation',
      label: '操作',
      width: 140,
      // fixed: 'right',
      actionList: [
        // {
        //   label: '查看',
        //   kind: 'primary',
        //   type: 'dialog',
        //   title: '',
        //   footerHide: true,
        //   addr: ''
        // },
        {
          filter: 'row.acceptStatus==2',
          label: '接收',
          kind: 'primary',
          type: 'request',
          data: {
            id: '{id}',
            acceptStatus: '3'
          },
          addr: 'accept'
        },
        {
          filter: 'row.acceptStatus==2',
          label: '退回',
          kind: 'primary',
          type: 'request',
          data: {
            id: '{id}',
            acceptStatus: '4'
          },
          addr: 'sendBack'
        },
        {
          label: '评阅',
          kind: 'primary',
          type: 'router',
          addr: '/shell/custom/expertManage/thesisOnlineReview?id={reviewCode}'
        }
      ]
    },
    {
      name: 'sendTypeName',
      label: '送审方式',
      width: 120
    },
    {
      name: 'firstSubjectName',
      label: '一级学科',
      width: 100
    },
    {
      name: 'secondSubjectName',
      label: '二级学科',
      width: 100
    },
    {
      name: 'researchAera',
      label: '论文涉及的研究方向',
      width: 160
    },
    {
      name: 'titleCn',
      label: '论文题目',
      width: 100
    },
    {
      name: 'titleEn',
      label: '论文英文题目',
      width: 140
    },
    {
      name: 'sendTime',
      label: '发送时间',
      width: 150
    },
    {
      name: 'receiveTime',
      label: '接收时间',
      width: 150
    },
    {
      name: 'reviewEndTime',
      label: '论文评阅截止时间',
      width: 150
    },
    {
      name: 'expertFee',
      label: '专家评审费',
      width: 110
    }
  ],
  legent: [
    {
      css: 'table-row-highlight',
      expression: 'row.acceptStatus==1'
    },
    {
      css: 'table-row-invalid',
      expression: 'row.acceptStatus==2'
    }
  ]
}
export default Thesis



// WEBPACK FOOTER //
// ./src/layout/regularPage/config/thesisManage/thesis.js